export default __webpack_public_path__ + "static/media/7.ec5712e4.jpeg";